<template>
  <div>
    <separator class="mb-separation" text="Resultado de Contratos" />

    <callout
      v-if="userHasPermissions('provider.contract.add')"
      border-color="primary-1"
      class="mb-3"
      class-main="py-3"
      :has-toggle="false"
    >
      <div class="row d-flex justify-content-center">
        <action-button
          class="border w-40 btn"
          i="fas fa-file-plus color-primary-1"
          text="Presione aquí para añadir contrato"
          @click="onAddContractHandler"
        />
      </div>
    </callout>

    <div v-if="results.length > 0">
      <callout
        v-for="(contract, index) in results"
        :key="index"
        :border-color="
          (contract.amendments || []).length > 0 ? 'primary-1' : ''
        "
        class="mb-3"
        class-main="bg-secondary-13"
        class-panel="p-2"
        :has-toggle="(contract.amendments || []).length > 0"
      >
        <row :model="contract" @remove="onRemoveContractHandler" />

        <template #edition>
          <callout
            v-for="(amendment, idx) in contract.amendments"
            :key="idx"
            class-main="bg-white mb-2"
            :has-border="false"
            :has-toggle="false"
          >
            <row
              :contract-info="contract"
              :is-child="true"
              :model="amendment"
            />
          </callout>
        </template>
      </callout>
    </div>
    <div class="text-right mt-3">
      <action-button
        v-if="contractValidate"
        class="mx-2"
        i="fas fa-file-plus pr-1"
        text="Añadir"
        variant="success"
        @click="onAddContractHandler"
      />
    </div>
  </div>
</template>

<script>
import alert from '@/mixins/alert.mixin';
import Row from './components/RowResult';

import {
  getContracts as _getContracts,
  existsContractForCurrentAcademicYear as _existsContractForCurrentAcademicYear,
  removeContract as _removeContract,
} from '@/modules/provider/api';

export default {
  name: 'Result',
  components: {
    Row,
  },
  mixins: [alert],
  data() {
    return {
      results: [],
      isOpen: false,
      existsContract: null,
    };
  },
  computed: {
    contractValidate() {
      return (
        this.existsContract === false &&
        this.userHasPermissions('provider.contract.add') &&
        this.results.length > 0
      );
    },
    companyId() {
      return this.$route.params.companyId;
    },
  },
  async mounted() {
    await this.getContracts();
    await this.existsContractForCurrentAcademicYear();
  },
  methods: {
    async getContracts() {
      await _getContracts({
        companyId: this.$route.params.companyId,
        fiscalYearId: this.$route.params.fiscalYearId,
      })
        .then((res) => {
          this.results = res.data;
        })
        .catch(() =>
          this.ShowToast(
            'Error',
            'Ocurrió un error cargando los datos',
            'error'
          )
        );
    },
    async onAddContractHandler() {
      this.$router.push({ name: 'contractAddEdit' });
    },
    async existsContractForCurrentAcademicYear() {
      this.existsContract = (
        await _existsContractForCurrentAcademicYear(this.companyId)
      ).data;
    },
    async onRemoveContractHandler({ id }) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea eliminar el contrato seleccionado?',
        'Sí',
        'No'
      );

      if (!answer) return;

      try {
        const { data } = await _removeContract(id);
        if (!data) {
          this.ShowToast(
            'Error',
            'Ocurrió un error eliminando el contracto.',
            'error'
          );
          return;
        }

        this.ShowToast(
          'Proceso Exitoso',
          'El contracto ha sido eliminado exitosamente.',
          'success'
        );
        this.getContracts();
      } catch (error) {
        this.ShowToast('Error', error.response.data.message, 'error');
      }
    },
  },
};
</script>
